import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CommunityWizard } from '../components/CommunityBlueprint';

export default function CommunityWizardPage() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleComplete = (community) => {
    const target = community?.slug || community?.id || '';
    if (target) {
      navigate(`/communities/${target}`);
    } else {
      navigate('/communities');
    }
  };

  return <CommunityWizard user={user} onComplete={handleComplete} />;
}
